(ns rothko.theme.sandi.colours
  (:require [garden.color :as color :refer [rgb rgba]]
            [rothko.styles.vars.common :as common]))

(def colours
  (merge
   common/colours
   {:blue-border-dark (rgb 54 61 85)
    :blue-darkest (rgb 20 25 48)
    :blue-dark (rgb 32 39 67)
    :blue-light (rgb 32 138 231)
    :orange (rgb 242 123 54)
    :green (rgb 34 188 155)
    :green-dark (rgb 24 158 85)
    :audio-level-green (rgb 112 249 63)
    :audio-level-red (rgb 247 28 28)
    :audio-level-yellow (rgb 243 235 45)
    :grey-bg-gradient-dark (rgba 198 200 207 0.4)
    :grey-bg-gradient-light (rgb 241 241 243)
    :red (rgb 234 107 107)
    :red-dark (rgb 169 68 66)
    :red-light (rgba 169 68 66 0.2)}))
